import React from 'react';
import PropTypes from 'prop-types';

const PointOfSale = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='point-of-sale-title'>{altText}</title>
      <path fill='currentColor' d='M17 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'/>
      <path fill='currentColor' fillRule='evenodd' d='M6 3.25a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h3.25v1.5H5.5a2.25 2.25 0 0 0-2.25 2.25v6a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25v-6a2.25 2.25 0 0 0-2.25-2.25h-7.75v-1.5H14a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75H6Zm7.25 4h-6.5v-2.5h6.5v2.5Zm-7.75 4.5h13a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 .75-.75Z' clipRule='evenodd'/>
    </svg>
  );
};

PointOfSale.propTypes = {
  altText: PropTypes.string
};

export default PointOfSale;
